import { RcClasses } from '../../../foundation';
export var RcVirtualizedMenuClasses = RcClasses(['paper'], 'RcVirtualizedMenu');
